import lang from '@/lang/middleware/homepage';

import { getUserMessage } from '@/graphql/queries/util/user-message';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const user = store.getters['user/get'];
  const jumbotron = {
    image: {
      image: { fallback: require('~/assets/images/jumbotrons/homepage-savings.webp') },
      text: store.$i18n.t('jumbotron.imageAlt')
    },
    type: 'homepage'
  };

  if (user && user.fname) {
    await $apolloQuery(getUserMessage).then(r => store.commit('utils/setUserMessage', r));
    const day = new Date().toLocaleString('en-IE', { weekday: 'long' });
    const name = user.fname;
    jumbotron.subtitle = store.getters['utils/getUserMessage'];
    jumbotron.title = store.$i18n.t('jumbotron.title.loggedIn', { day, name });
  } else {
    jumbotron.class = 'not-logged-in';
    jumbotron.extra = 'site-jumbotron-homepage-cta';
    jumbotron.subtitle = store.$i18n.t('jumbotron.subtitle');
    jumbotron.title = store.$i18n.t('jumbotron.title.notLoggedIn');
  }
  store.commit('jumbotron/SET_JUMBOTRON', jumbotron);
  store.commit('pageContent/setHead', { title: store.$i18n.t('title'), description: store.$i18n.t('description'), image: 'index' });
};
